@if (gameTable) {
  <div class="table-detail-card card h-100 w-100 flex-grow-1 table-detail-card-clickable" tabindex="0"
       [attr.aria-label]="'Apri dettaglio del tavolo ' + gameTable.tableName" (click)="onCardClick($event)"
       (keydown)="onCardKeydown($event)">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-start gap-2">
        <div class="d-flex flex-column gap-1 flex-grow-1">
          <h5 class="fw-bold mb-0">{{ gameTable.tableName }}</h5>
          <div class="table-subtitle fw-bold">{{ gameTable.playedGame.gameName }}</div>
        </div>
        @if (canEdit()) {
          <a class="btn btn-warning btn-sm flex-shrink-0" title="Puoi modificare"
             [attr.aria-label]="'Modifica tavolo: ' + gameTable.tableName"
             [routerLink]="['/tables/edit', gameTable.id]"
             (click)="$event.stopPropagation()">
            <i class="bi bi-pencil-fill" aria-hidden="true"></i>
          </a>
        }
      </div>
    </div>

    <div class="card-body">
      <div class="table-image-container mb-3">
        @if (gameTable.playedGame.imageUrl && !hasImageError()) {
          <img [src]="gameTable.playedGame.imageUrl" [alt]="gameTable.playedGame.gameName" class="table-image" loading="lazy" (error)="onImageError()"/>
        } @else {
          <span class="text-muted">Immagine del gioco non disponibile</span>
        }
      </div>

      <div class="table-meta">
        <div class="meta-row">
          <span class="fw-bold">Giocatori:</span>
          <span>da {{ gameTable.minPlayers }} a {{ gameTable.maxPlayers }}</span>
        </div>
        @if (gameTable.organization?.organizationName) {
          <div class="meta-row">
            <span class="fw-bold">Organizzazione:</span>
            <span>{{ gameTable.organization?.organizationName }}</span>
          </div>
        }
        @let event = gameTable.event;
        @if (event && event.name) {
          <div class="meta-row">
            <span class="fw-bold">Evento:</span>
            @if (event.id) {
              <a [routerLink]="['/events/detail', event.id]" class="link-primary text-decoration-underline">{{
                  event.name
                }}</a>
            } @else {
              <span>{{ event.name }}</span>
            }
          </div>
        }
        @if (distanceLabel()) {
          <div class="meta-row">
            <span class="fw-bold">Distanza:</span>
            <span>{{ distanceLabel() }}</span>
          </div>
        }
      </div>
    </div>
  </div>
}
